import { render, staticRenderFns } from "./GatewaysPanel.global.vue?vue&type=template&id=1beba9d6&lang=html&"
import script from "./GatewaysPanel.global.vue?vue&type=script&lang=ts&"
export * from "./GatewaysPanel.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports